import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { AuthStatus, useAuth } from "../../hooks/useAuth"
import { useWelcomeStore } from "../../stores/welcomeStore"

interface IProps {}

const Connexion = (props: IProps) => {
  const navigate = useNavigate()
  const { study } = useWelcomeStore()
  const { status, login, loginError, setLoginError, loading } = useAuth()
  const { t } = useTranslation()
  const [inputs, setInputs] = useState({
    email: "",
    password: ""
  })
  const [passwordVisible, setPasswordVisible] = useState(false)

  const loginForm = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const email = inputs["email"]
    const password = inputs["password"]
    login(email, password)
  }

  useEffect(() => {
    if (status === AuthStatus.Authenticated) navigate("/")
  }, [status, navigate])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (loginError) setLoginError(false)
    const name = e?.target?.name
    const value = e?.target?.value
    setInputs((values) => ({ ...values, [name]: value }))
  }

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible)
  }

  return (
    <div className="flex items-center justify-center bg-cortexx-100 w-screen h-screen">
      <div className="bg-cortexx-50 w-full md:w-2/3 h-screen">
        <div className="flex items-center justify-center my-4">
          {study ? (
            <div className="bg-cortexx-50">
              <img
                src={study?.administrative_information.logo_url}
                style={{ height: "80px" }}
                alt="RP Logo"
                loading="lazy"
              />
            </div>
          ) : null}
        </div>
        <div className="flex items-center h-full w-full flex-col mt-24">
          <div className="flex items-center justify-center w-full my-4">
            <div className="flex-row w-1/2">
              <h1 className="font-semibold text-2xl text-cortexx-900  text-center">
                {t("auth.login")}
              </h1>
              <h2 className="font-normal text-l text-cortexx-900  text-center mt-4">
                {t("auth.enter_credentials")}
              </h2>
            </div>
          </div>
          <form className="flex flex-col items-center m-6" onSubmit={loginForm}>
            <div className="flex flex-col items-left justify-center mb-4">
              <h2 className="font-semibold text-lg text-cortexx-550">
                {t("auth.email")}
              </h2>
              <input
                className="border-2 border-slate-300 rounded-xl w-72 py-2 px-3 text-gray-700 mb-3 leading-tight focus:outline-none"
                name="email"
                type="email"
                placeholder="email"
                onChange={handleChange}
              />
              <h2 className="font-semibold text-lg text-cortexx-550">
                {t("auth.password")}
              </h2>
              <div className="flex border-2 border-slate-300 rounded-xl  mb-2 leading-tight file:w-72 items-center">
                <input
                  className="py-2 px-3 text-gray-700 w-64 rounded-xl  focus:outline-none"
                  name="password"
                  type={passwordVisible ? "text" : "password"}
                  placeholder="mot de passe"
                  onChange={handleChange}
                />
                <img
                  src={
                    passwordVisible
                      ? "/images/eye.svg"
                      : "/images/eye_unlock.svg"
                  }
                  style={{ height: "22px" }}
                  alt="close"
                  loading="lazy"
                  onClick={togglePasswordVisibility}
                />
              </div>
              {loginError && (
                <div className="text-center text-red-500 text-sm">
                  <a href="/reset-password-request">
                    {t("auth.wrong_credentials")}
                  </a>
                </div>
              )}
              <div className="text-end pb-2">
                <a href="/reset-password-request">
                  <p className="font-extralight text-sm text-cortexx-1000 text-end mt-1">
                    {t("auth.forgotten_password")}
                  </p>
                </a>
              </div>
              <div className="flex justify-end items-end mt-4">
                {loading ? (
                  <button className="bg-cortexx-100 text-cortexx-550 font-semibold py-2 px-4 rounded-full">
                    <div className="flex-row flex items-end justify-end mx-2 my-1">
                      <p>{t("auth.login")}</p>
                      <div className="ml-2">
                        <img
                          src="/images/fade-stagger-circles.svg"
                          style={{ height: "20px" }}
                          alt="close"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </button>
                ) : (
                  <button
                    className="bg-cortexx-550 hover:opacity-60 rounded-2xl py-3 px-4 text-cortexx-50 font-semibold"
                    type="submit"
                  >
                    <p>{t("auth.login")}</p>
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Connexion
